import React from 'react';
import styled from 'styled-components';
import {
  OrderIsCompleted,
  OrderCanBeRefunded,
  Shipping,
} from '../Status/OrderStatus';
import * as PATH from '../../../lib/routes/path';
import { Flex } from '../../../components/common/atom/Layout';
import { TextLink } from '../../../components/common/molecules/TextLink';

function doShowRefundButton(id, status) {
  if (OrderCanBeRefunded.includes(status)) {
    return (
      <BorderButton
        link={`${PATH.MYPAGE_ORDER_REFUND}/${id}`}
        size={14}
        color="brownGrey"
      >
        주문취소
      </BorderButton>
    );
  }
}

function doShowOrderFinishButtons(item, conversionItemId, status) {
  if (OrderIsCompleted.includes(status)) {
    // 일반 주문인 경우 허용
    if (!item.shippingToAffiliate) {
      return orderFinishButtonsView(conversionItemId);
    }
    // 제휴사 주문 중, 다운로드 잠금이 풀린 경우 허용
    if (!item.downloadLocked) {
      return orderFinishButtonsView(conversionItemId);
    }
  }
}

function orderFinishButtonsView(conversionItemId) {
  return (
    <>
      <BorderButton link={PATH.MYPAGE_REVIEW} size={14} color="orangePink">
        리뷰 작성
      </BorderButton>
      <BorderButton
        link={`${PATH.MYPAGE_ORDER_RESULT}/${conversionItemId}`}
        color="orangePink"
        size={14}
      >
        결과 보기
      </BorderButton>
    </>
  );
}

function doShowShippingButton(status, item) {
  if (Shipping.includes(status)) {
    // 배송을 받지 않는 고객
    if (item.shipment === null) return;
    return (
      <BorderButton
        link={item.shipment.trackingUri}
        size={14}
        color="orangePink"
      >
        배송 조회
      </BorderButton>
    );
  }
}

const OrderResultButton = ({ id, item }) => {
  return (
    <Flex justifyContent="space-around">
      {doShowRefundButton(id, item.status)}
      {doShowOrderFinishButtons(item, item.id, item.status)}
      {doShowShippingButton(item.status, item)}
    </Flex>
  );
};

export default React.memo(OrderResultButton);

export const BorderButton = styled(TextLink)`
  border: 1px solid ${(props) => props.theme.color[props.color]};
  border-radius: 6px;
  padding: 0.375rem 1.125rem;
  background: ${(props) =>
    props.color === 'brownGrey'
      ? props.theme.color.brownGrey
      : props.theme.background.white};
  color: ${(props) =>
    props.color === 'brownGrey'
      ? props.theme.background.white
      : props.theme.color};
`;
